module.exports = __webpack_public_path__ + "img/lunbo.27b89b69.png";